import React, { useContext, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import './menu.css';
import Cookies from 'js-cookie';
import { useAppContext } from '../Context/AppContext';
import { Link, useNavigate } from 'react-router-dom';

import facebook from '../logos/facebook.png';
import instagram from '../logos/instagram.png';
import threads from '../logos/threads.png';
import youtube from '../logos/youtube.png';

import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

const Menu = (props) => {
    const { BASE_PATH } = useContext(useAppContext);
    const { navbardata = [], companydetails = {} } = props;

    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    // Get current language from cookie (default: English)
    const lang = Cookies.get('lg') || 'en';
   const handlesearch = (e) => {
        setSearch(e.target.value)
    }

    const searchbutton = () => {
        if (search.length > 0 && search.trim() != '') {
            navigate("/search/" + search);
            window.location.reload();
        }
    }
    // Manual Menu Configuration based on language
    const menuData = {
        en: [
            {
                title: "Entertainment",
                subtitle: [
                    { title: "Movies", url: "/movies" },
                    { title: "Movie Review", url: "/movie-review" },
                    { title: "Trailers", url: "/trailers" },
                    { title: "Tv Live", url: "/tv-live" }
                ]
            },
            {
                title: "Celebrity",
                subtitle: [
                    { title: "Film Gossip", url: "/film-gossip" },
                    { title: "Fashion", url: "/fashion" }
                ]
            },
            { title: "Music", url: "/music" },
            {
                title: "Gallery",
                subtitle: [
                    { title: "Paparazzi", url: "/paparazzi" },
                    { title: "Photo Stories", url: "/photo-stories" }   // Fixed typo: photo=stories → photo-stories
                ]
            },
            { title: "Sports", url: "/sports" },
            {
                title: "Lifestyle",
                subtitle: [
                    { title: "Auto News", url: "/auto-news" },
                     { title: "Horoscope", url: "/horoscope" },
                    { title: "Health & Wellness", url: "/health-wellness" },
                    { title: "Numerology", url: "/numerology" },
                    { title: "Travel", url: "/travel" },
                    { title: "Tech & Gadgets", url: "/tech-gadets" },
                ]
            },
            { title: "Features", url: "/features" }   // Changed from "/music" to proper path
        ],
      hi: [
  {
    title: "फिल्मी खबरें",
    subtitle: [
      { title: "सिनेमा", url: "/movies" },
      { title: "रिव्यु", url: "/movie-review" },
      { title: "म्यूज़िक", url: "/music" },
      { title: "ट्रेलर", url: "/trailers" },
      { title: "टीवी Live", url: "/tv-live" }
    ]
  },
  {
    title: "बॉलीवुड",
    subtitle: [
      { title: "फिल्मी गॉसिप", url: "/film-gossip" },
      { title: "फैशन", url: "/fashion" }
    ]
  },
  { title: "खेल", url: "/sports" },
  {
    title: "लाइफस्टाइल",
    subtitle: [
      { title: "हेल्थ", url: "/health-wellness" },
      { title: "टूरिज़्म", url: "/travel" },
      { title: "तकनीकी", url: "/tech-gadgets" }
    ]
  },
  { title: "फीचर", url: "/features" }
],
    tl: [
        {title: "RJ Suneetha కబుర్లు", url: "/rj-suneetha-kaburulu"},

        {title: "ఫిల్మ్ మసాలా",subtitle:[
            {title: "టాలీవుడ్ కబుర్లు", url: "/tollywood-kaburulu"},
            {title: "ఫిల్మ్ ఈవెంట్స్", url: "/film-events"}, ]},
  
  {
    title: "టాలీవుడ్",
    subtitle: [
      { title: "సినిమా", url: "/movies" },
      { title: "ట్రైలర్స్", url: "/trailers" },
      { title: "సంగీతం", url: "/music" },
      { title: "ఫిల్మ్ రివ్యూ", url: "/movie-review" }
    ]
  },
  {
    title: "ఫోటో & వీడియో",
    subtitle: [
      { title: "వెబ్ స్టోరీ", url: "/photo-stories" }
    ]
  },
 {
    title: "ఫిల్మ్ గాసిప్",
    url: "/film-gossip"   // ✅ SAME as DB
  },
]
    };

    const finalMenu = menuData[lang] || menuData.en;

   const handleLanguage = (selectedLang) => {
    Cookies.set('lg', selectedLang);

    if (selectedLang === "en") {
        window.location.href = "/";   // ✅ English → root
    } else {
        window.location.href = `/${selectedLang}`; // ✅ tl / hi
    }
};

    const handleSearch = (e) => setSearch(e.target.value);

    const doSearch = () => {
        if (search.trim()) {
            navigate(`/search/${search.trim()}`);
            window.location.reload();
        }
    };

    // Hide menu for visual stories detail pages
    const param2 = window.location.pathname.split('/');
    if (param2.length >= 3 && param2[1] === 'visualstories' && param2[2].length > 0) {
        return null;
    }

    return (
        <Navbar expand="lg" className="bg-body-tertiary" sticky="top">
            <Container>
                {/* Language Selector - Mobile Only */}
                <NavDropdown
                    className="d-lg-none d-block remove-arrows no-content"
                    title={
                        <img
                            src={companydetails.languageicon || "https://cdn.mobilemasala.com/assets/front_end/images/adimage/Languageicon1.webp"}
                            alt="Language"
                            style={{ width: '30px' }}
                        />
                    }
                >
                    <NavDropdown.Item onClick={() => handleLanguage('en')}>English</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleLanguage('tl')}>తెలుగు</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleLanguage('hi')}>हिन्दी</NavDropdown.Item>
                </NavDropdown>

                {/* Logo */}
                <Navbar.Brand href="/" className="m-0">
                    <img
                        src={companydetails.companylogo || "https://cdn.mobilemasala.com/cdn/MMLogoNew-1726639349396.png"}
                        alt="Mobile Masala"
                        loading="lazy"
                        style={{ height: '45px' }}
                    />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" />

                 <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-lg`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
                        placement="end"
                    >
                    <Offcanvas.Header closeButton>
                            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>

                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Nav className="justify-content-end align-items-lg-center flex-grow-1">

                            {/* Dynamic Menu Items */}
                            {finalMenu.map((item, index) => {
                                if (item.subtitle && item.subtitle.length > 0) {
                                    return (
                                        <NavDropdown title={item.title} key={index} id={`dropdown-${index}`}>
                                            {item.subtitle.map((sub, i) => (
                                                <NavDropdown.Item
                                                    as={Link}
                                                    to={sub.url}
                                                    key={i}
                                                >
                                                    {sub.title}
                                                </NavDropdown.Item>
                                            ))}
                                        </NavDropdown>
                                    );
                                }
                                return (
                                    <Nav.Link
                                        as={Link}
                                        to={item.url}
                                        key={index}
                                    >
                                        {item.title}
                                    </Nav.Link>
                                );
                            })}

                                <>
                                    <InputGroup >
                                        <Form.Control
                                            placeholder="Search"
                                            aria-label="Recipient's username"
                                            aria-describedby="basic-addon2"
                                            className='search'
                                            value={search}
                                            onChange={(e) => handlesearch(e)}
                                        />
                                        <InputGroup.Text id="basic-addon2" onClick={() => searchbutton()}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                            </svg></InputGroup.Text>
                                    </InputGroup>
                                </>

                            {/* Language Selector - Desktop Only */}
                            <NavDropdown
                                className="remove-arrows no-content d-lg-block d-none"
                                title={
                                    <img
                                        src={companydetails.languageicon || "https://cdn.mobilemasala.com/assets/front_end/images/adimage/Languageicon1.webp"}
                                        alt="Language"
                                        style={{ width: '30px' }}
                                    />
                                }
                            >
                                <NavDropdown.Item onClick={() => handleLanguage('en')}>English</NavDropdown.Item>
                                <NavDropdown.Item onClick={() => handleLanguage('tl')}>తెలుగు</NavDropdown.Item>
                                <NavDropdown.Item onClick={() => handleLanguage('hi')}>हिन्दी</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>

                        {/* Social Icons - Mobile Only */}
                        <div className="icons d-lg-none d-block mt-3">
                            <a href={companydetails.companyfacebook} target="_blank" rel="noreferrer">
                                <img src={facebook} alt="Facebook" />
                            </a>
                            <a href={companydetails.companyinstagram} target="_blank" rel="noreferrer">
                                <img src={instagram} alt="Instagram" />
                            </a>
                            <a href={companydetails.companythreads} target="_blank" rel="noreferrer">
                                <img src={threads} alt="Threads" />
                            </a>
                            <a href={companydetails.companyyoutube} target="_blank" rel="noreferrer">
                                <img src={youtube} alt="YouTube" />
                            </a>
                        </div>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    );
};

export default Menu;